import { Helmet } from "react-helmet-async";
import { BUSINESS } from "@/data/servicesData";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export const Seo = ({ title, description, path = "", image, keywords = [], jsonLd = [] }) => {
  const url = `${ORIGIN}${path}`;
  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: BUSINESS.name,
  image: `${ORIGIN}/logo192.png`,
  telephone: BUSINESS.phoneRaw,
  email: BUSINESS.email,
  url: ORIGIN,
  priceRange: "££",
  address: { "@type": "PostalAddress", addressLocality: "Swansea", addressRegion: "Wales", addressCountry: "GB" },
  geo: { "@type": "GeoCoordinates", latitude: BUSINESS.geo.lat, longitude: BUSINESS.geo.lng },
  areaServed: ["Swansea", "Mumbles", "Sketty", "Gower", "Uplands", "Morriston", "Gorseinon", "Killay"].map((n) => ({ "@type": "City", name: n })),
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "08:00",
    closes: "18:00",
  },
});

export const serviceSchema = (service, origin = ORIGIN) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: service.name,
  provider: { "@type": "HomeAndConstructionBusiness", name: BUSINESS.name, telephone: BUSINESS.phoneRaw },
  areaServed: { "@type": "City", name: "Swansea" },
  url: `${origin}/services/${service.slug}`,
  description: service.metaDescription,
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items, origin = ORIGIN) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${origin}${it.path}`,
  })),
});
